'use client';

var INITIAL_FLOATING_CONFIG = {
    placement: 'bottom-start',
    position: 'absolute',
    useWindowAsFlippingContainer: false,
    enablePortal: false,
    isFlip: true
};
var INITIAL_DROPDOWN_STYLES = {
    maxHeight: 200,
    title: 'Title',
    width: 0,
    allowSearch: true,
    emptyString: '',
    searchBoxPlaceholder: 'Search'
};

export { INITIAL_DROPDOWN_STYLES, INITIAL_FLOATING_CONFIG };
//# sourceMappingURL=constants.js.map
